import styled from 'styled-components/macro'

/** Read by screen readers, not shown on screen. */
const FoodSafetyVisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
`

export default FoodSafetyVisuallyHidden
